export enum AlertType {
  Info = 'תקין',
  Warning = 'אזהרה',
  Danger = 'לא תקין'
}
